exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.figure-count{\n\n    font-size: 30px;\n    font-weight: 700;\n}\n\n", ""]);

// exports
